<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="card pt-4" [class.shadow-none]="false">
      <div class="card-header align-items-start">
        <div class="d-flex flex-column">
          <h2 class="modal-title mb-1">Add event</h2>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <h3>Base information</h3>
        </div>

        <div class="row spacing-15">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'Event Name'"
              [type]="'text'"
              [placeholder]="'Enter event name'"
              [(value)]="event_name"
            />
          </div>
          <div class="col-lg-6 col-12">
            <app-selectorini
              [options]="eventTypes"
              [displayKey]="'event_type_name'"
              [placeholder]="'Select event type'"
              [multiple]="false"
              [(value)]="event_type_id"
            />
          </div>
        </div>

        <div class="row g-4 spacing-30">
          <div class="col-lg-12 col-12">
            <label class="ms-2 f-14 fw-bold spacing-15">Event description</label>
            <app-markdown-editorini
              [value]="event_description"
              (valueChange)="event_description = $event"
            />
          </div>
        </div>
        <div class="row">
          <h3>Date information</h3>
        </div>
        <div class="row g-4 spacing-30">
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="'Start Date'"
              [type]="'datetime-local'"
              [placeholder]="'Enter start date'"
              [(value)]="start_date"
            />
          </div>
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="'End Date'"
              [type]="'datetime-local'"
              [placeholder]="'Enter end date'"
              [(value)]="end_date"
            />
          </div>
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="'Registration deadline'"
              [type]="'datetime-local'"
              [placeholder]="'Enter registration deadline'"
              [(value)]="registration_deadline"
            />
          </div>
        </div>
        <div class="row">
          <h3>Address information</h3>
        </div>
        <div class="row g-4 spacing-15">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'Address'"
              [placeholder]="'Address'"
              [type]="'text'"
              [(value)]="address"
            />
          </div>
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'City'"
              [placeholder]="'City'"
              [type]="'text'"
              [(value)]="city"
            />
          </div>
        </div>
        <div class="row g-4 spacing-30">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'Postal code'"
              [placeholder]="'Postal code'"
              [type]="'number'"
              [(value)]="postal_code"
            />
          </div>
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'Country'"
              [placeholder]="'Country'"
              [type]="'text'"
              [(value)]="country"
            />
          </div>
        </div>

        <div class="row g-4 spacing-30">
          <div class="col-lg-6 col-12">
            <h4>Event logo</h4>
            <app-fileorini
              [accept]="'image/*'"
              (filesChanged)="logo = $event[0]"
            />
          </div>

          <div class="col-lg-6 col-12">
            <h4>Header image</h4>
            <app-fileorini
              [accept]="'image/*'"
              (filesChanged)="header = $event[0]"
            />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <app-button
              [variant]="'primary'"
              [label]="'Create event'"
              [iconClass]="'fa fa-plus'"
              (clicked)="addEvent()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
